export const INDUSTRIES = [
  { name: "Universities", note: "Multi-campus compliance, term-time delivery", icon: "graduation-cap" },
  { name: "Schools", note: "Safeguarding-aware engineers, holiday windows", icon: "school" },
  { name: "Restaurants", note: "TR19 kitchen extract, out-of-hours cleans", icon: "utensils" },
  { name: "Laboratories", note: "Clean-air critical environments, LEV testing", icon: "flask-conical" },
  { name: "Banks & Offices", note: "Air quality, IAQ monitoring, AHU servicing", icon: "building-2" },
  { name: "Hotels", note: "Guest comfort, plant rooms, kitchen extract", icon: "bed-double" },
  { name: "Pharmacies", note: "Clean storage, ventilation compliance", icon: "pill" },
  { name: "Healthcare", note: "Critical ventilation, fire damper testing", icon: "stethoscope" },
];

export const COMMON_ISSUES = [
  {
    problem: "Stuffy air, odours or dust complaints",
    solution: "Full duct cleaning, filter upgrades and air-quality testing to restore healthy airflow.",
  },
  {
    problem: "Uncertainty around fire damper testing, TM44 or TR19",
    solution: "Scheduled testing, detailed reporting and certification — keeping you fully aligned with regulations.",
  },
  {
    problem: "HVAC running inefficiently and driving up bills",
    solution: "Optimise system performance through maintenance, cleaning and energy-efficient adjustments.",
  },
  {
    problem: "Costly system failures disrupting operations",
    solution: "Proactive plans that catch issues early — fewer surprise failures, fewer emergency callouts.",
  },
  {
    problem: "Grease and debris build-up increasing fire risk",
    solution: "Deep extract and duct cleaning to TR19 standards, reducing fire risk and ensuring safe operation.",
  },
  {
    problem: "Hot and cold spots across the building",
    solution: "Balance and optimise HVAC to deliver consistent, controlled temperatures across the space.",
  },
  {
    problem: "Missed checks, weak reporting and reactive service",
    solution: "Transparent reporting, clear schedules and a proactive approach — total visibility, year round.",
  },
  {
    problem: "Multiple contractors handling different HVAC elements",
    solution: "Single HVAC partner covering cleaning, compliance, maintenance and testing under one roof.",
  },
];
